'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { AddedToCart, addedToCartItemsAtom, buildExperienceCartItem } from '@feat/feat-cart/added-to-cart';
import { useCartItem } from '@feat/feat-cart/item';
import { useSetAtom } from 'jotai';
import { useAppExperienceRecommendation } from '../_hooks/use-app-experience-recommendation';
import { AppEdpBookingFlow } from './app-edp-booking-flow';
import { useExperienceFilterContext } from './app-experience-filter-provider';
type AppEdpBookingModalProps = {
  isOpen: boolean;
  onClose: () => void;
  availableDates?: string[];
  availableDatesArePreliminary?: boolean;
};
export function AppEdpBookingModal(t0) {
  const $ = _c(11);
  const {
    isOpen,
    onClose,
    availableDates,
    availableDatesArePreliminary
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <Modal.Header onClose={onClose}>Datum wählen</Modal.Header>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== availableDates || $[3] !== availableDatesArePreliminary || $[4] !== onClose) {
    t2 = <AppEdpBookingModalContent onClose={onClose} availableDates={availableDates} availableDatesArePreliminary={availableDatesArePreliminary} />;
    $[2] = availableDates;
    $[3] = availableDatesArePreliminary;
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isOpen || $[7] !== onClose || $[8] !== t1 || $[9] !== t2) {
    t3 = <Modal isOpen={isOpen} onClose={onClose}>{t1}{t2}</Modal>;
    $[6] = isOpen;
    $[7] = onClose;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
type AppEdpBookingModalContentProps = {
  onClose: () => void;
  availableDates?: string[];
  availableDatesArePreliminary?: boolean;
};
function AppEdpBookingModalContent(t0) {
  const $ = _c(14);
  const {
    onClose,
    availableDates,
    availableDatesArePreliminary
  } = t0;
  const {
    filter,
    experience
  } = useExperienceFilterContext();
  const {
    addExperience
  } = useCartItem();
  const setAddedToCartItems = useSetAtom(addedToCartItemsAtom);
  const {
    recommendation,
    loadRecommendation
  } = useAppExperienceRecommendation(experience.publicId);
  let t1;
  if ($[0] !== addExperience || $[1] !== experience || $[2] !== filter.selectedOptions || $[3] !== loadRecommendation || $[4] !== onClose || $[5] !== setAddedToCartItems) {
    t1 = (timeslot, t2) => {
      const {
        onSuccess,
        onError
      } = t2;
      if (!filter.selectedOptions) {
        onError();
        return;
      }
      addExperience({
        timeslotId: timeslot.id,
        experienceId: experience.id,
        selectedOptions: filter.selectedOptions
      }, {
        onSuccess: () => {
          setAddedToCartItems([buildExperienceCartItem(experience, {
            startDate: timeslot.date,
            startTimezone: timeslot.startTimezone
          })]);
          loadRecommendation();
          onSuccess();
          onClose();
        },
        onError
      });
    };
    $[0] = addExperience;
    $[1] = experience;
    $[2] = filter.selectedOptions;
    $[3] = loadRecommendation;
    $[4] = onClose;
    $[5] = setAddedToCartItems;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleSubmit = t1;
  let t2;
  if ($[7] !== recommendation) {
    t2 = <AddedToCart recommendation={recommendation} />;
    $[7] = recommendation;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== availableDates || $[10] !== availableDatesArePreliminary || $[11] !== handleSubmit || $[12] !== t2) {
    t3 = <AppEdpBookingFlow availableDates={availableDates} availableDatesArePreliminary={availableDatesArePreliminary} submitLabel="In den Warenkorb" onSubmit={handleSubmit} extraBottomContent={t2} />;
    $[9] = availableDates;
    $[10] = availableDatesArePreliminary;
    $[11] = handleSubmit;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}